/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleDiagnosticsControllerLookupInvitesByEmailQueryResponse, TrimbleDiagnosticsControllerLookupInvitesByEmailQueryParams, TrimbleDiagnosticsControllerLookupInvitesByEmail400, TrimbleDiagnosticsControllerLookupInvitesByEmail401, TrimbleDiagnosticsControllerLookupInvitesByEmail403, TrimbleDiagnosticsControllerLookupInvitesByEmail404 } from "../../models/trimbleDiagnosticsController/TrimbleDiagnosticsControllerLookupInvitesByEmail";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { trimbleDiagnosticsControllerLookupInvitesByEmail } from "../../clients/trimble-diagnosticsService/trimbleDiagnosticsControllerLookupInvitesByEmail";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const trimbleDiagnosticsControllerLookupInvitesByEmailQueryKey = (params: TrimbleDiagnosticsControllerLookupInvitesByEmailQueryParams) => [{
  url: '/api/v1/trimble-invite-diagnostics'
}, ...(params ? [params] : [])] as const;
export type TrimbleDiagnosticsControllerLookupInvitesByEmailQueryKey = ReturnType<typeof trimbleDiagnosticsControllerLookupInvitesByEmailQueryKey>;
export function trimbleDiagnosticsControllerLookupInvitesByEmailQueryOptions(params: TrimbleDiagnosticsControllerLookupInvitesByEmailQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = trimbleDiagnosticsControllerLookupInvitesByEmailQueryKey(params);
  return queryOptions<TrimbleDiagnosticsControllerLookupInvitesByEmailQueryResponse, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupInvitesByEmail400 | TrimbleDiagnosticsControllerLookupInvitesByEmail401 | TrimbleDiagnosticsControllerLookupInvitesByEmail403 | TrimbleDiagnosticsControllerLookupInvitesByEmail404>, TrimbleDiagnosticsControllerLookupInvitesByEmailQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return trimbleDiagnosticsControllerLookupInvitesByEmail(params, config);
    }
  });
}

/**
 * @summary Diagnose Document Crunch and IAM invitations for an email
 * {@link /api/v1/trimble-invite-diagnostics}
 */
export function useTrimbleDiagnosticsControllerLookupInvitesByEmail<TData = TrimbleDiagnosticsControllerLookupInvitesByEmailQueryResponse, TQueryData = TrimbleDiagnosticsControllerLookupInvitesByEmailQueryResponse, TQueryKey extends QueryKey = TrimbleDiagnosticsControllerLookupInvitesByEmailQueryKey>(params: TrimbleDiagnosticsControllerLookupInvitesByEmailQueryParams, options: {
  query?: Partial<QueryObserverOptions<TrimbleDiagnosticsControllerLookupInvitesByEmailQueryResponse, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupInvitesByEmail400 | TrimbleDiagnosticsControllerLookupInvitesByEmail401 | TrimbleDiagnosticsControllerLookupInvitesByEmail403 | TrimbleDiagnosticsControllerLookupInvitesByEmail404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? trimbleDiagnosticsControllerLookupInvitesByEmailQueryKey(params);
  const query = useQuery({
    ...trimbleDiagnosticsControllerLookupInvitesByEmailQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupInvitesByEmail400 | TrimbleDiagnosticsControllerLookupInvitesByEmail401 | TrimbleDiagnosticsControllerLookupInvitesByEmail403 | TrimbleDiagnosticsControllerLookupInvitesByEmail404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}